export default __webpack_public_path__ + "austin_sites_eu.2cecd57d.csv";